<template>
	<!-- <div class="report-side-panel bench-overview-side-panel q-box-shadow fromleft"> -->
	<div class="lft-view report-side-panel customer-engagement q-box-shadow">
		<report-header @updateEvent="updateReportData" @downloadEvent="exportExcel"></report-header>
		<!-- table set -->
		<div class="table-wrapper" ref="tableWrapperLap">
			<div class="master-table-head-box">
				<div class="master-table-head consultant-workload">
					<div class="co-w-thone-country co-w-thone-country-label dropdown-setter left-pos-cell" data-setter="oe">
						<div class="master-table-text left-table-header" @click="sortTable('oe')">OE</div>
						<div class="master-table-opt"></div>
						<button type="button" class="vs-con-dropdown parent-dropdown" data-getter="oe">
							<a href.prevent class="a-icon">
								<!-- <i class="filter-icon-i"></i> -->
								<i :class="(oeSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
							</a>
						</button>
						<Dropdown>
							<ul>
								<li>
									<input
										oninput="this.value = this.value.replace(/[^A-Za-z0-9-,.;'&/.() ]|^ /g,'')"
										type="text"
										class="dropdown-input"
										placeholder="Filter"
										v-model="oeSearch"
									/>
								</li>
							</ul>
						</Dropdown>
					</div>
				</div>
			</div>
			<div class="master-table vb" :class="loaderClass" v-bar>
				<scroll-sync group="report" vertical>
					<!-- add here -->
					<template v-for="(relation, index) in relations">
						<div class="report-left-list consultant-workload" :key="index" ref="unitRelationRow">
							<div class="each-turn consultant-w">
								<div class="master-table-text right-table-header alloc-value">
									<p class="left-td">{{relation.shortName}}</p>
								</div>
							</div>
						</div>
					</template>
					<div class="no-item" v-if="relations.length < 1">No items found !</div>
				</scroll-sync>
			</div>
		</div>

		<!-- bottom -->
		<div class="table-results">
			<div class="table-result">
				<p class="left-td bottom-left-heading">Own</p>
			</div>
			<div class="table-result">
				<p class="left-td bottom-left-heading">External</p>
			</div>
			<div class="table-result">
				<p class="left-td bottom-left-heading">Total</p>
			</div>
		</div>
	</div>
</template>

<script>
    const ReportHeader = () => import("../ReportHeader");
    const Dropdown = () => import("../../../common/Dropdown");

    import settings from "../../../../config/settings";
    import searchKeys from "../../../../config/searchKeys";
    import _ from "lodash";

    export default {
        name: "QcentrisunitRelation",
        data() {
            return {
                masterTableWidth: 0,
                loadMore: true,
                loaderClass: ""
            };
        },
        components: {
            ReportHeader,
            Dropdown
        },
        computed: {
            /**
             * Bench report cosultant list from store
             */
            relations: function () {
                return this.$store.state.reports.qcentrisUnitTurnoverRelations;
            },
            /**
             * Get the bench overview filter data from store
             */
            filter: function () {
                return this.$store.state.reports.qcentrisUnitTurnoverFilter;
            },
            /**
             * if loading more rows for bench overview
             */
            isLoadingMoreRows: function () {
                return this.$store.state.reports.loadingCustomerEngagementRows;
            },
            /**
             * Model binding for OE search
             */
            oeSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.qcentrisUnitTurnoverFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(
                        f => f.fieldName === searchKeys.oe
                    );
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : "";
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.oe,
                        value: value
                    };
                    this.$store.commit("setUnitTurnoverSearchData", data);
                }
            }
        },
        methods: {
            /**
             * set the table width
             */
            setTableWidth: function () {
                setTimeout(() => {
                    let element = document.querySelector(
                        ".report-allocations .gm-scroll-view"
                    );
                    if (element) {
                        this.masterTableWidth = element.scrollWidth;
                    }
                }, 200);
            },
            /**
             * Handle the scroll event on report relation section
             * Get the scroll height and on limit, fetch data
             */
            handleScroll: function () {
                // get the parent element
                let parent = document.getElementById("bench-scroll-table");
                // get the child element having scroll
                let child = parent.getElementsByClassName("scroll-sync-container");
                // get the first child, first having the scroll
                let firstChild = child[0];
                // on scrolling the child
                firstChild.addEventListener("scroll", () => {
                    // get the scroll height
                    let height = firstChild.scrollHeight - firstChild.scrollTop;
                    // scrolled down
                    if (height <= settings.load_more_height_report) {
                        // load more data
                        this.loadMoreResults();
                    }
                });
            },
            /**
             * Load more report data
             */
            loadMoreResults: function () {
                if (this.loadMore) {
                    this.loadMore = false;
                    this.$store.dispatch("fetchMoreBenchReport").then(() => {
                        this.loadMore = true;
                    });
                }
            },
            /**
             * Request with the search result once the user stopped typing
             */
            submitSearchResult: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = settings.initial_forecast_row_count;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    // fetch the bench report with the search data
                    this.$store.dispatch("fetchQcentrisUnitTurnover", filter);
                    this.$store.dispatch("fetchReportAggregates", filter);
                }, 700);
            },
            /**
             * Sort the table on click
             */
            sortTable: function (column) {
                let rowCount = settings.initial_forecast_row_count;
                //clone the filter
                let filter = this.filter;
                let filterData = _.cloneDeep(filter);
                // if no sort set or sort set for another column
                if (!filter.sortColumn || filter.sortColumn !== searchKeys[column]) {
                    this.$store.commit("setQcentrisTurnoverSort", {
                        column: searchKeys[column],
                        order: "ASC"
                    });
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'ASC';
                } else if (
                    filter.sortColumn === searchKeys[column] &&
                    filter.sortOrder === "ASC"
                ) {
                    this.$store.commit("setQcentrisTurnoverSort", {
                        column: searchKeys[column],
                        order: "DESC"
                    });
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'DESC';
                } else if (
                    filter.sortColumn === searchKeys[column] &&
                    filter.sortOrder === "DESC"
                ) {
                    this.$store.commit("setQcentrisTurnoverSort", {
                        column: searchKeys[column],
                        order: "ASC"
                    });
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'ASC';
                }
                if (this.relations && this.relations.length) {
                    rowCount = this.relations.length;
                }
                // set row count
                filterData.pageSize = rowCount;
                // set the page number to 1
                filterData.pageNumber = 1;
                // request data with filter
                this.$store.dispatch("fetchQcentrisUnitTurnover", filterData);
            },

            /**
             * Mouse wheel on right table should scroll the horizontal area.
             * @constructor
             */
            HeadHorizontalScroll: function () {
                let ScrollElement = this.$refs.masterHeadScroll,
                    scrollableElement = document.querySelector(
                        ".report-alloc-benchoverview .gm-scroll-view"
                    ),
                    i = 0;

                //Mouse wheel and scroll event
                ScrollElement.addEventListener("wheel", function (e) {
                    //When dragging to left side
                    if (e.deltaY < 0 && !e.shiftKey) {
                        if (i >= 0) {
                            //if Scroll left == 0
                            scrollableElement.scrollLeft = i;
                            i = i - 50;
                        } else {
                            i = 0;
                        }
                    }
                    //Mouse wheel and horizontal scroll for allocation's headers
                    else if (e.deltaY > 0 && !e.shiftKey) {
                        if (i <= scrollableElement.scrollWidth) {
                            //if Scroll left !== end of the div
                            scrollableElement.scrollLeft = i;
                            i = i + 50;
                        } else {
                            i = scrollableElement.scrollWidth;
                        }
                    }
                });
            },
            updateReportData: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = this.relations.length || 25;
                this.$store.dispatch("fetchQcentrisUnitTurnover", filter);
                this.$store.dispatch("fetchReportAggregates", filter);
            },
            exportExcel: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = this.relations.length || 25;
                // send request
                this.$store.dispatch("exportUnitTurnover", filter);
            },
            setLoaderClass: function () {
                this.loaderClass =
                    this.$refs.unitRelationRow && this.$refs.unitRelationRow.length > 0
                        ? "master-table-loaded"
                        : "";
            },
              wrappingLap: function(){
                // this.$refs.table-wrapper-lap
                var el = this.$refs.tableWrapperLap;
                if(!el.closest('.table-wrapper-outer')){
                    
                    var wrapper = document.createElement('div');
                    wrapper.classList.add('table-wrapper-outer');
                    el.parentNode.insertBefore(wrapper, el);
                    wrapper.appendChild(el);
                }
            }
        },
        updated() {
            this.setTableWidth();
            this.setLoaderClass();
        },
        mounted() {
            // this.handleScroll();
            setTimeout(function () {
                // this.HeadHorizontalScroll()
            }, 500);
            
            this.wrappingLap();
        },
        watch: {
            oeSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                }
            }
        }
    };
</script>

<style scoped>
	.scroll-sync-container.vb-content {
		border-bottom: 1px solid #dee1e3;
	}

	/* Header cols */
	.customer-engagement {
		width: 1015px;
		min-width: 1015px;
	}

	.customer-field {
		width: 163px;
		min-width: 163px;
		padding-left: 43px;
	}

	.consultant-field {
		width: 122px;
		min-width: 122px;
	}

	.project-field {
		width: 96px;
		min-width: 96px;
	}

	.country-field {
		width: 101px;
		min-width: 101px;
	}

	.oe-field {
		width: 90px;
		min-width: 90px;
	}

	.level-field {
		width: 82px;
		min-width: 82px;
	}

	.start-field {
		width: 82px;
		min-width: 82px;
	}

	.end-field {
		width: 82px;
		min-width: 82px;
	}

	.hrrate-field {
		width: 94px;
		min-width: 94px;
	}

	.timeleft-field {
		width: 103px;
		min-width: 103px;
	}

	/* Layout */
	.report-side-panel {
		min-width: 423px;
		width: 423px;
	}

	.table-results {
		/* padding-top: 25px; */
	}

	.report-side-panel .master-table-head {
		justify-content: flex-start;
		-webkit-justify-content: flex-start;
		-moz-justify-content: flex-start;
	}

	.co-w-thone-country-label {
		padding-left: 49px;
		min-width: 148px;
		width: 148px;
		max-width: 148px;
	}

	.qcentric-unit-turnover-view .consultant-workload > div.consultant-w {
		width: 100%;
		max-width: 100%;
		min-width: 100%;
	}

	.master-table {
		max-height: calc(100vh - 300px);
		min-height: calc(100vh - 300px);
		height: calc(100vh - 300px);
	}
</style>